import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient,HttpHeaders,HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeDetailsService {

  APIEndpoint = environment.APIEndpoint;
  private baseUrl=this.APIEndpoint;


  constructor(private http: HttpClient) { }


  getEmployeeDetails(): Observable<any[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<any[]>(this.baseUrl+'/getemployeeDetails',{ headers });
  }
  getTrackDetails(form:any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.baseUrl+'/getTrackDetails',form,{ headers });
  }
  getMonthlyAttendance(form:any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.baseUrl+'/getMonthlyAttendanceDetails',form,{ headers });
  }
}
